import { camelCase } from 'lodash';
import { toISODateFormat } from 'works/legacy/lib/date-helper';
import {
  RATE_FIELDS,
  SHIFTS,
  WEEK_DAYS,
  CORE_DAY_INPUT_KEYS,
  FLOAT_DAY_INPUT_KEYS,
  CORE_NIGHT_INPUT_KEYS,
  FLOAT_NIGHT_INPUT_KEYS,
  DYNAMIC_RATES_INPUT_KEYS,
} from '@scheduling/services';
import {
  UnitRateType,
  SimplifiedWorkforceGroupType,
} from '@scheduling/graphql';
import {
  SelectOrganizationUnitType,
  VariableRatesType,
  WeekDaysRates,
} from '@institutions/graphql';

function buildShiftRateKey(shift: string) {
  return `${camelCase(shift)}IncentiveRates`;
}

export function getTransformedData({
  selectedWorkforceGroups,
  effectiveDate,
  endDate,
  selectedOrgsUnits,
  ratesValues,
}: {
  selectedWorkforceGroups: SimplifiedWorkforceGroupType[];
  effectiveDate: string;
  endDate: string;
  selectedOrgsUnits: SelectOrganizationUnitType[];
  ratesValues: UnitRateType;
}) {
  // TODO: Remove all this logic changing the mutation to receive the same fields as in workforce_group_unit_rates.
  function getAllVariableUnitRates() {
    function buildWeekdayKeyValue(
      days: WeekDaysRates,
      key: string,
      index: number
    ) {
      days[WEEK_DAYS[index] as keyof WeekDaysRates] = ratesValues[
        key as keyof UnitRateType
      ] as number;

      return days;
    }

    function buildShiftKeyValue(
      shifts: VariableRatesType,
      fields: string[],
      index: number
    ) {
      shifts[buildShiftRateKey(SHIFTS[index]) as keyof VariableRatesType] =
        fields.reduce(buildWeekdayKeyValue, {} as WeekDaysRates);
      return shifts;
    }

    return RATE_FIELDS.reduce(buildShiftKeyValue, {} as VariableRatesType);
  }

  function getAllDynamicRates() {
    function buildDefaultTypeKeyValue(
      types: Record<string, number>,
      key: string
    ) {
      types[key] = ratesValues[key as keyof UnitRateType] as number;
      return types;
    }

    return DYNAMIC_RATES_INPUT_KEYS.reduce(buildDefaultTypeKeyValue, {}) as {
      priceRange: number;
      incentiveIncrement: number;
    };
  }

  const variableRates = getAllVariableUnitRates();

  const dynamicRates = getAllDynamicRates();

  return {
    workforceGroupIds: selectedWorkforceGroups.map((wfg) => wfg.id),
    effectiveDate: effectiveDate && toISODateFormat(effectiveDate),
    endDate: (endDate !== '' && toISODateFormat(endDate)) || null,
    organizationUnitIds: selectedOrgsUnits.map((unit) => unit.id),
    rates: {
      ...dynamicRates,
      variableRates,
    },
  };
}

export function filterFormData(formRawData: UnitRateType) {
  const formFilteredData = {};

  function assignValuesByKeys(keys: string[], defaultValue?: number) {
    return keys.forEach(
      (key) =>
        // eslint-disable-next-line
        // @ts-ignore: not sure how to solve this issue
        (formFilteredData[key] =
          formRawData[key as keyof UnitRateType] ?? defaultValue)
    );
  }

  assignValuesByKeys(CORE_DAY_INPUT_KEYS);
  assignValuesByKeys(CORE_NIGHT_INPUT_KEYS);
  assignValuesByKeys(FLOAT_DAY_INPUT_KEYS);
  assignValuesByKeys(FLOAT_NIGHT_INPUT_KEYS);

  assignValuesByKeys(DYNAMIC_RATES_INPUT_KEYS, 0);

  return formFilteredData as UnitRateType;
}
